module.exports = __webpack_public_path__ + "img/facepaint-2_en.9fbf7df.jpg";